import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { NavService } from '../services/nav.service';

@Injectable({
  providedIn: 'root'
})
export class NavGuard implements CanActivate {
  constructor(private navService: NavService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const fullPath = route.pathFromRoot.map(p => p.url.map(r => r.path).join('/')).join('/');
    console.log('ROUTE///' , fullPath);
    this.navService.currentUrl = fullPath;
    return true;
  }
}
